module.exports = __webpack_public_path__ + "static/media/featured-img2.a5a3dd54.jpg";